import IOH from '../../utils/IOH';

const mergeKeys = (keyA, keyB) => {
  if (Array.isArray(keyA) && Array.isArray(keyB)) {
    return [...keyA, ...keyB];
  }
  if (Array.isArray(keyA) && typeof keyB === 'string') {
    return [...keyA, keyB];
  }
  if (Array.isArray(keyB) && typeof keyA === 'string') {
    return [keyA, ...keyB];
  }

  return [keyA, keyB];
};

export default {
  namespaced: true,
  state: {
    value: {},
  },
  mutations: {
    SET(state, config) {
      const mapBooleans = (inputObj, parentKey) => {
        const mappedObject = {};

        Object.keys(inputObj).forEach((key) => {
          const value = inputObj[key];
          const isBooleanValue = [0, '0', 1, '1'].includes(value);

          if (typeof value === 'object' && value !== null) {
            mappedObject[key] = mapBooleans(value, key);
          } else if (['show', 'linkToUsagePage', 'default'].includes(key) && isBooleanValue) {
            mappedObject[key] = [1, '1'].includes(value);
          } else if (parentKey === 'show' && isBooleanValue) {
            mappedObject[key] = [1, '1'].includes(value);
          } else {
            mappedObject[key] = value;
          }
        });

        return mappedObject;
      };

      state.value = mapBooleans(config);
    },
  },
  getters: {
    getRecursive: (state) => (key, defaultValue = null) => {
      let keyString = '';

      if (Array.isArray(key)) {
        keyString = key.join('.');
      } else if (typeof key === 'string') {
        keyString = key;
      } else {
        return defaultValue;
      }

      return IOH.recVal(state.value, keyString, defaultValue);
    },
    getSummationLabel: (state, getters) => (key, defaultLabel) => getters.getRecursive(mergeKeys('configPanel.summations.labels', key), defaultLabel),
  },
};
